import { client as request } from "./request";
import { Staff } from "./company-api";

export interface Client {
  id: number;
  name: string;
}

function Client(data: any): Client {
  return {
    id: data.office.officeId,
    name: `${data.company.name} ${data.office.name}`
  };
}

/**
 * 発注者の情報を得る
 */
export async function getAllClients(): Promise<Client[]> {
  const res = await request.get("get_all_clients.php");
  return res.clientList.map(Client);
}

/**
 * 発注担当者の情報を得る
 */
export async function getAllClientStaffs(projectId = "") {
  const res = await request.get("get_all_client_staffs.php", { projectId });
  return res.staffList as Staff[];
}
